import Form from '../../lib/forms'

class ModContactForm {
  constructor () {
    this.prefix = '.c-mod_contactForm'
    this.init()
  }

  init () {
    const forms = document.querySelectorAll(this.prefix)

    forms.forEach((formEl) => {
      // Saltar elementos ocultos (display: none en el propio elemento o ancestro)
      if (formEl.offsetParent === null) return

      // Crear una instancia de Form por cada módulo visible
      const instance = new Form(this.prefix)
      instance.init(formEl)
    })
  }
}

export default ModContactForm
